/*
 * @Author: 刘小博
 * @Date: 2023-02-17 10:40:28
 * @LastEditTime: 2023-04-14 16:54:29
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\file-info-manage\modules\accountInfoManageRouter.js
 * 账号信息管理
 */
const accountInfoManageRouter = [
  // 芒哥 综合服务商账号 列表
  {
    path: '/mg/cooperation-manage/service-list',
    name: 'MgManageServiceList',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/cooperation-manage/list.vue' // 待删除
        '@/views/mg/file-info-manage/account-info-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '账号信息管理', //二级菜单
      title: '综合服务商账号',
    },
  },
  // 芒哥 批量更新账号
  {
    path: '/mg/cooperation-manage/batch-update-account-number',
    name: 'MgManageServiceBatchUpdateAccountNumber',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/cooperation-manage/batchUpdateAccountNumber.vue' // 待删除
        '@/views/mg/file-info-manage/account-info-manage/Update.vue'
      ),
    meta: {
      SecondaryMenu: '账号信息管理', //二级菜单
      title: '批量更新账号',
      breadcrumb: [
        {
          title: '综合服务商账号',
          name: 'MgManageServiceList',
        },
      ],
    },
  },

  // 芒哥 综合服务商 添加
  {
    path: '/mg/cooperation-manage/service-add/:id/:client_id/:meta_type',
    name: 'MgManageServiceAdd',
    component: () =>
      import(
        /*webpackChunkName:"mg" */
        // '@/views/mg/cooperation-manage/add.vue' // 待删除
        '@/views/mg/file-info-manage/account-info-manage/Add.vue'
      ),
    meta: {
      SecondaryMenu: '账号信息管理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '开通综合服务商账号',
        breadcrumb: [
          {
            title: '综合服务商账号',
            name: 'MgManageServiceList',
          },
        ],
      },
      2: {
        title: '编辑综合服务商账号',
        breadcrumb: [
          {
            title: '综合服务商账号',
            name: 'MgManageServiceList',
          },
          {
            title: '综合服务商账号详情',
            name: 'MgManageServiceDetail',
          },
        ],
      },
      3: {
        title: '编辑综合服务商账号',
        breadcrumb: [
          {
            title: '账号使用统计',
            name: 'MgAccountCondition',
          },
          {
            title: '综合服务商账号详情',
            name: 'MgManageServiceDetail',
          },
        ],
      },
    },
  },
]
export default accountInfoManageRouter
